<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Reglas comerciales
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Acciones Comerciales</span>
      <span> /</span>
      <span>Reglas comerciales</span>
    </p>
  </div>
</div>
<!-- Heading -->

<div class="row">
  <div class="col p-0">
    <!-- Nav tabs -->
    <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-3 text-uppercase'" [contentClass]="'p-0'"
      class="nav-reglas p-0" (getActiveTab)="onTabActivated($event)">
      <!--Panel 1-->
      <mdb-tab heading="Descuentos especiales">
        <ng-container *ngIf="activeTabHeading === TAB_DESCUENTOS_ESPECIALES">
          <app-descuentos-especiales [permiteUnidadNegocio]="permiteUnidadNegocio"
            [optionsTipoDescuento]='optionsTipoDescuento'></app-descuentos-especiales>
        </ng-container>
      </mdb-tab>
      <!--Panel 2-->
      <mdb-tab heading="Descuentos máximos" *ngIf="permiteVerDescuentoTope">
        <ng-container *ngIf="activeTabHeading === TAB_DESCUENTOS_MAXIMOS">
          <app-descuentos-topes [permiteUnidadNegocio]="permiteUnidadNegocio"
            [optionsTipoDescuento]='optionsTipoDescuento'>
          </app-descuentos-topes>
        </ng-container>
      </mdb-tab>
      <!--Panel 3-->
      <mdb-tab heading="Promociones" [disabled]="!promocionesHabilitado"
        [customClass]="!promocionesHabilitado ? 'disabled-tab' : ''">
        <ng-container *ngIf="activeTabHeading === TAB_PROMOCIONES">
          <app-promociones [permiteUnidadNegocio]="permiteUnidadNegocio"
            [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio" [optionsTipoDescuento]='optionsTipoDescuento'>
          </app-promociones>
        </ng-container>
      </mdb-tab>
      <!--Panel 4-->
      <mdb-tab heading="Combos" [disabled]="!combosHabilitado" [customClass]="!combosHabilitado ? 'disabled-tab' : ''">
        <ng-container *ngIf="activeTabHeading === TAB_COMBOS">
          <app-combos [permiteUnidadNegocio]="permiteUnidadNegocio" [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio">
          </app-combos>
        </ng-container>
      </mdb-tab>
    </mdb-tabset>
  </div>
</div>
